import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Offer} from '../../../../../../core/models/offer/offer.model';
import {OfferBasicItemComponent} from '../../../../../components/offer-basic-item/offer-basic-item.component';
import {OfferResourceService} from '../../../../../../core/services/impl/offer-resource.service';
import {LanguageService} from '../../../../../services/language.service';

@Component({
  selector: 'app-offers-comparison-panel-offer',
  templateUrl: './offers-comparison-panel-offer.component.html'
})
export class OffersComparisonPanelOfferComponent extends OfferBasicItemComponent implements OnInit {

  @Input() offer: Offer;

  @Output() remove: EventEmitter<void> = new EventEmitter<void>();

  constructor(offerResourceService: OfferResourceService,
              language: LanguageService) {
    super(offerResourceService, language);
  }

  ngOnInit() {
    this.createBoxes(this.offer);
    this.setLogo(this.offer);
  }

  removeOffer(): void {
    this.remove.emit();
  }

}
